<template>
  <div id="action">

    <transition name="fade">
      <div v-if="spinner.is_loading" class="spinner-container">
        <spinner size="big" message="Veuillez patienter..." :font-size="20"></spinner>
      </div>
    </transition>

    <section class="heading-title heading-arrow-bottom align-top">
      <div class="container">

        <div class="text-center">
          <h3>Interface de pilotage des <b>ZONES</b></h3>
          <p>Controlez l'éclairage des différentes voies simplement.</p>
        </div>

      </div>
    </section>

    <div class="container mt-30">
      <div v-if="user">Utilisateur connecté : <b>{{user.login}}</b></div>
      <div v-if="user">Description : <b>{{user.description}}</b></div>
      <div>Après une action veuillez patienter, le retour d'état peut prendre de quelques secondes à plusieurs minutes.</div>
    </div>

    <div class="container mt-30" v-if="zones">

      <div class="" v-for="(zone, i_zone) in zones" v-if="(zone.voies.voie_1 && zone.voies.voie_1.is_show) || (zone.voies.voie_2 && zone.voies.voie_2.is_show)">

        <div class="heading-title heading-line-single text-right mb-0">
          <h3>{{zone.libelle}} <span>Zone</span></h3>
        </div>

        <div class="timeline">
          <div class="timeline-hline"></div>

          <!-- VOIE 1 -->
          <div class="blog-post-item" v-if="zone.voies.voie_1 && zone.voies.voie_1.is_show">

            <div v-bind:class="{'timeline-entry c-pointer': true, 'active': zones_active[i_zone].voie_1}" @click.prevent="toggleAllumageExtinctionZone(i_zone, 1)">
              <i class="fa fa-refresh rotating mt-5" v-if="zones_active[i_zone].is_voie_1_maj_en_cours"></i>
              <i class="fa fa-power-off" v-else></i>
              <div class="timeline-vline"></div>
            </div>

            <h2 class="timeline-title-position">
              <i><a href="Javascript:void(0)">Voie 1</a></i>
            </h2>

            <div class="timeline-infos">

              <div v-if="zone.voies.voie_1.date_limite" class="blog-post-info fs-14">
                <i class="fa fa-calendar-times-o"></i>
                Date de limitation d'utilisation :
                <b><i>{{zone.voies.voie_1.date_limite | moment("DD/MM/YYYY HH:mm")}}</i></b>.
              </div>

              <div v-else class="blog-post-info fs-14">
                <i class="fa fa-calendar-times-o"></i>
                Pas de limitation dans le temps.
              </div>

              <div class="blog-post-info list-inline fs-14">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="">En cliquant sur ce bouton vous vous apprêtez à
                  <span v-if="zones_active[i_zone].voie_1" class="font-weight-bold">éteindre</span>
                  <span v-if="!zones_active[i_zone].voie_1" class="font-weight-bold">allumer</span>
                  un éclairage public.

                  <transition name="fade">
                    <div class="alert alert-danger mt-5" v-if="zone.voies.voie_1.is_error_date_limite">
                      <strong>Impossible !</strong> Le délai imparti d'utilisation est dépassé.<br/>
                    </div>
                  </transition>

                </span>
              </div>

            </div>

          </div>

          <!-- VOIE 2 -->
          <div class="blog-post-item" v-if="zone.voies.voie_2 && zone.voies.voie_2.is_show">

            <div v-bind:class="{'timeline-entry c-pointer': true, 'active': zones_active[i_zone].voie_2}" @click.prevent="toggleAllumageExtinctionZone(i_zone, 2)">
              <i class="fa fa-refresh rotating mt-5" v-if="zones_active[i_zone].is_voie_2_maj_en_cours"></i>
              <i class="fa fa-power-off" v-else></i>
              <div class="timeline-vline"></div>
            </div>

            <h2 class="timeline-title-position">
              <i><a href="Javascript:void(0)">Voie 2</a></i>
            </h2>

            <div class="timeline-infos">

              <div v-if="zone.voies.voie_2.date_limite" class="blog-post-info fs-14">
                <i class="fa fa-calendar-times-o"></i>
                Date de limitation d'utilisation :
                <b><i>{{zone.voies.voie_2.date_limite | moment("DD/MM/YYYY HH:mm")}}</i></b>.
              </div>

              <div v-else class="blog-post-info  fs-14">
                <i class="fa fa-calendar-times-o"></i>
                Pas de limitation dans le temps.
              </div>

              <div class="blog-post-info list-inline  fs-14">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="">En cliquant sur ce bouton vous vous apprêtez à
                  <span v-if="zones_active[i_zone].voie_2" class="font-weight-bold">éteindre</span>
                  <span v-if="!zones_active[i_zone].voie_2" class="font-weight-bold">allumer</span>
                  un éclairage public.

                  <transition name="fade">
                    <div class="alert alert-danger mt-5" v-if="zone.voies.voie_2.is_error_date_limite">
                      <strong>Impossible !</strong> Le délai imparti d'utilisation est dépassé.<br/>
                    </div>
                  </transition>

                </span>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

import Axios from 'axios';
import Moment from 'moment';
import Spinner from 'vue-simple-spinner';

require('vue-style-loader!@/assets/css/app/action.css');

var func = require('@/assets/js/fonctions.js');

export default {

  data () {
    return {

      // Liste des zones
      zones: [],

      // zones_active
      zones_active: [],
      // Zones dont une action à été faite
      zones_clic: [],

      user: undefined,

      // Chargement
      spinner: {
        is_loading: false
      }

    }
  },

  props: ['userParam'],

  created () {

    // Check utilisateur connecté
    this.$parent.$emit('updateUser');

  },

  components: {
    Spinner,
  },

  watch: {

    /*
    * Utilisateur en cours
    */
    userParam: function(user){

      var _this = this;

      _this.user = user;

      // Retourne les zones administrateur
      _this.getZones();
      setInterval(function() {
        _this.getZones();
      }, 10000);

    }

  },

  mounted () {
    this.spinner.is_loading = true;
  },

  methods: {

    /*
    * Active la zone
    */
    activeZone: function(zone, i_zone, i_voie) {

      var current_timestamp = Moment().valueOf();

      if (zone.voies["voie_" + i_voie]) {

        // Horaire force ?
        this.zones_active[i_zone]["voie_" + i_voie] = zone.voies["voie_" + i_voie].is_allume;

      }

      return true;
    },

    /*
    * Initialise l'etat des boutons en fonction des tranches horaires
    */
    initEtatZone: function() {

      // Allume / Eteint les boutons suivant l'horaire en cours
      for (var i_zone = 0, length_zone = this.zones.length; i_zone < length_zone; i_zone++) {

        if (!this.zones_active[i_zone]) {
          this.zones_active[i_zone] = {
            voie_1: false,
            voie_2: false,
          };
        }

        if (!this.zones_clic[i_zone]) {
          this.zones_clic[i_zone] = {
            voie_1: false,
            voie_2: false,
          };
        }

        var zone = this.zones[i_zone];

        if (!this.activeZone(zone, i_zone, 1)) continue;
        if (!this.activeZone(zone, i_zone, 2)) continue;

        this.checkDateLimite(i_zone, 1);
        this.checkDateLimite(i_zone, 2);

      }
    },

    /*
    * Vérifie si la date de limite d'utilisation est dépassé
    */
    checkDateLimite(i_zone, i_voie) {
      if (!this.zones[i_zone].voies["voie_" + i_voie].date_limite) return true;
      if (Moment(this.zones[i_zone].voies["voie_" + i_voie].date_limite).valueOf() < Moment().valueOf()) {
        this.zones[i_zone].voies["voie_" + i_voie].is_error_date_limite = true;
        this.$forceUpdate();
        return false;
      }
      return true;
    },

    /*
    * Allume / Eteint la zone
    */
    toggleAllumageExtinctionZone: function(i_zone, i_voie) {

      var _this = this;

      // Vérifie la date limite d'utilisation
      if (!this.checkDateLimite(i_zone, i_voie)) return;

      // Vérifie qu'il n'y ai pas de commande envoyé
      if (this.zones_active[i_zone]["is_voie_" + i_voie + "_maj_en_cours"]) {
        this.$popup({ message: 'Veuillez patienter...', delay: 20, backgroundColor: "rgba(234, 109, 100, 0.8)" });
        return;
      }

      this.$popup({ message: 'Commande envoyée' });

      var libelle_action = "";
      var action = 0;

      // Déjà eu une action ? -> Arret de forcage
      if (this.zones_clic[i_zone]["voie_" + i_voie]) {
        action = 0;
        this.zones_clic[i_zone]["voie_" + i_voie] = false;
      } else {
        action = 1;
        this.zones_clic[i_zone]["voie_" + i_voie] = true;
      }

      Axios.post(func.url_backend + '/api/nodlight/sites/' + this.user.id_site + '/zones/' + this.zones[i_zone].id_zone + '/voies/' + (i_voie-1) + '/utilisateurs/' + this.user._id + '/action/' + action, {a: libelle_action}).then((response) => {

        this.zones_active[i_zone]["is_voie_" + i_voie + "_maj_en_cours"] = true;

        // Réinit du refresh
        setTimeout(function() {
          _this.zones_active[i_zone]["is_voie_" + i_voie + "_maj_en_cours"] = false;
          _this.$forceUpdate();
        }, 60000);

        _this.$forceUpdate();

      }).catch( (error) => {
        console.log(error);
      });

    },

    /*
    * Retourne les zones de l'administrateur
    */
    getZones: function() {

      var _this = this;

      Axios.get(func.url_backend + '/api/nodlight/sites/' + _this.user.id_site + '/zones').then((response) => {

        if (!response.data.ok) {
          _this.spinner.is_loading = false;
          return;
        }

        // Mise en session
        var zones = response.data.obj.zones;
        var new_zones = [];

        // Zone de l'admin
        for (var i_zone_admin = 0, length_zone_admin = zones.length; i_zone_admin < length_zone_admin; i_zone_admin++) {

          var zone_admin = zones[i_zone_admin];

          // Zone de l'utilisateur
          var keys = Object.keys(_this.user.zones);

          for(var i_zone_user = 0, length_zone_user = keys.length; i_zone_user < length_zone_user; i_zone_user++) {

            // Comparaison entre les zones et ce que l'utilisateur à le droit
            if (keys[i_zone_user] != zone_admin.id_zone) continue;

            var user_voies = _this.user.zones[keys[i_zone_user]];

            if (!user_voies.voie_1.is_show && !user_voies.voie_2.is_show) continue;

            if (user_voies.voie_1.is_show) {
              user_voies.voie_1.interval_horaire_allumage = zone_admin.voies[0].interval_horaire_allumage;
              user_voies.voie_1.dates_exclusion = zone_admin.voies[0].dates_exclusion;
              user_voies.voie_1.is_allume = zone_admin.voies[0].is_allume;
            }

            if (user_voies.voie_1.is_show) {
              user_voies.voie_2.interval_horaire_allumage = zone_admin.voies[1].interval_horaire_allumage;
              user_voies.voie_2.dates_exclusion = zone_admin.voies[1].dates_exclusion;
              user_voies.voie_2.is_allume = zone_admin.voies[1].is_allume;
            }

            new_zones.push({id_zone: zone_admin.id_zone, libelle: zone_admin.libelle, voies: user_voies});

          }

        }

        _this.zones = new_zones;

        // Initialise l'etat des boutons
        _this.initEtatZone();

        _this.spinner.is_loading = false;

        _this.$forceUpdate();

      }).catch( (error) => {
        console.log(error);
      });

    },

  }



}

</script>



// WEBPACK FOOTER //
// src/components/Action.vue